/**
 * Mid-page Trust Strip (E5) - 3 anchor cards: Accuracy target, Daily sync, Compliance design.
 *
 * Trust amplifier between stat-row and 3 features. Reference: B2B SaaS legal/finance
 * (Clio, Ironclad, Stripe). Per analysis report 2026-05-05 (founder approved full).
 *
 * Compliance language follows legal-upl HARD VETO 2026-05-05 - all unshipped capabilities
 * use forward/target tense ("Mục tiêu", "Thiết kế theo", "lộ trình Day-1"). Switch to
 * present-tense only after F-B-04, F-X-01, F-U-22a/b/c, F-U-42/43/44, F-D-13/14 ship +
 * dpo@asklaw.vn MX active.
 */

export type TrustStripCatalog = {
  card_a_eyebrow: string;
  card_a_heading: string;
  card_a_body: string;
  card_a_link_label: string;
  card_a_link_href: string;
  card_b_eyebrow: string;
  card_b_heading: string;
  card_b_body: string;
  card_b_link_label: string;
  card_b_link_href: string;
  card_c_eyebrow: string;
  card_c_heading: string;
  card_c_body: string;
  card_c_link_label: string;
  card_c_link_href: string;
};

export const trustStripVi: TrustStripCatalog = {
  card_a_eyebrow: 'ĐỘ CHÍNH XÁC',
  card_a_heading: 'Mục tiêu trích dẫn Điều/Khoản đúng >=95%',
  card_a_body:
    'Mọi câu trả lời kèm trích dẫn Điều/Khoản bạn có thể kiểm chứng tại vbpl.moj.gov.vn. Phương pháp đo bằng bộ gold 50 và kết quả thực tế công bố tại trang minh bạch khi có dữ liệu.',
  card_a_link_label: 'Tìm hiểu cách Asklaw bảo đảm độ chính xác',
  card_a_link_href: '/blog/cach-asklaw-bao-dam-trich-dan-dung',

  card_b_eyebrow: 'CẬP NHẬT',
  card_b_heading: 'Đồng bộ hàng ngày từ vbpl.moj.gov.vn',
  card_b_body:
    'Pipeline tự động đưa văn bản mới vào hệ thống mỗi ngày, đánh dấu hiệu lực CHL/CCHL/HHL theo từng Điều. Văn bản hết hiệu lực bị từ chối trước khi trả kết quả.',
  card_b_link_label: 'Vì sao cập nhật hằng ngày quan trọng',
  card_b_link_href: '/blog/vi-sao-vbpl-cap-nhat-hang-ngay-quan-trong',

  card_c_eyebrow: 'TUÂN THỦ',
  card_c_heading: 'Thiết kế theo Luật AI 2026 + Luật PDP 2026',
  card_c_body:
    'Triển khai nhãn "Generated by Asklaw AI" trên mọi kết quả, nhật ký kiểm toán 12 tháng theo Luật AI 2026, liên hệ DPO tại dpo@asklaw.vn, nguyên tắc tối thiểu hoá dữ liệu, API xoá và xuất dữ liệu theo lộ trình Day-1.',
  card_c_link_label: 'Asklaw tuân thủ Luật AI + Luật PDP 2026',
  card_c_link_href: '/blog/asklaw-tuan-thu-luat-ai-va-luat-pdp-2026',
};

export const trustStripEn: TrustStripCatalog = {
  card_a_eyebrow: 'ACCURACY',
  card_a_heading: 'Target: Article/Clause citations correct >=95%',
  card_a_body:
    'Every answer ships with Article/Clause citations you can verify on vbpl.moj.gov.vn. Methodology uses our gold-50 set and live measured results are published on the transparency page as data becomes available.',
  card_a_link_label: 'How Asklaw ensures citation accuracy',
  card_a_link_href: '/en/ve-asklaw/how-asklaw-ensures-citation-accuracy',

  card_b_eyebrow: 'FRESHNESS',
  card_b_heading: 'Daily sync from official VBPL',
  card_b_body:
    'An automated pipeline ingests new documents from vbpl.moj.gov.vn daily and tags effective status (CHL/CCHL/HHL) per Article. Expired documents are refused before they reach an answer.',
  card_b_link_label: 'Why daily VBPL sync matters',
  card_b_link_href: '/en/ve-asklaw/why-daily-vbpl-sync-matters',

  card_c_eyebrow: 'COMPLIANCE',
  card_c_heading: 'Designed for Vietnam AI Act 2026 + PDPL 2026',
  card_c_body:
    'Roll-out includes a "Generated by Asklaw AI" label on every output, 12-month audit logs per Vietnam AI Act 2026, DPO contact at dpo@asklaw.vn, data-minimization principles, and Day-1 delete and export APIs on the roadmap.',
  card_c_link_label: 'Asklaw compliance with AI Act + PDPL 2026',
  card_c_link_href: '/en/ve-asklaw/asklaw-compliance-vietnam-ai-act-pdpl-2026',
};
